// Типы для марафона
export interface PayMarathonRequest {
    user_id: number;
    amount: number;
}

export interface MarathonUnpaidParticipant {
    id: number;
    user_id: number;
    name: string;
    surname: string;
    email: string;
    secret_cookie: string;
    amount: number;
    created_at: string;
}

export interface MarathonTicket {
    id: number;
    user_id: number;
    name: string;
    surname: string;
    email: string;
    secret_cookie: string;
    ticket_number: string;
    amount: number;
    created_at: string;
}

export interface MarathonQueueParticipant {
    id: number;
    user_id: number;
    name: string;
    surname: string;
    email: string;
    secret_cookie: string;
    position: number;
    created_at: string;
}

export interface MarathonAllTicket {
    id: number;
    user_id: number;
    name: string;
    surname: string;
    email: string;
    secret_cookie: string;
    ticket_number: string;
    amount: number;
    status: string;
    created_at: string;
}

export interface MarathonAccount {
    id: number;
    user_id: number;
    name: string;
    surname: string;
    email: string;
    secret_cookie: string;
    balance: number;
    created_at: string;
}

export interface MarathonBetParticipant {
    id: number;
    name: string;
    secret_cookie: string;
    photo: string;
}

export interface MarathonChooseTicket {
    ticket_id: number;
    count: number;
    participation_time: string;
    status: string;
    pay_for?: string | null;
    available_numbers: number[];
}

export const marathonEndpoints = {
    payMarathon: {
        query: (data: PayMarathonRequest) => ({
            url: "/admin/marathon/pay",
            method: "POST",
            body: data,
        }),
    },

    getMarathonUnpaidParticipants: {
        query: () => "/admin/marathon/unpaid-participants",
    },

    getMarathonAllTickets: {
        query: () => "/admin/marathon/all-tickets",
    },

    // Marathon statistics / types / import / clear / export
    getMarathonStatistics: {
        query: (params: { round?: number; type?: number }) => ({
            url: "/admin/marathon-results",
            params,
        }),
    },
    getMarathonTypes: {
        query: () => "/admin/marathon-results/types",
    },
    importMarathonResults: {
        query: (body: { round: number; type: number; csv_text: string }) => ({
            url: "/admin/marathon-results/import",
            method: "POST",
            body,
        }),
    },
    clearMarathonStatistics: {
        query: (params: { round?: number; type?: number }) => ({
            url: "/admin/marathon-results/clear",
            method: "DELETE",
            params,
        }),
    },
    exportMarathonStatistics: {
        query: (params: { round?: number; type?: number }) => ({
            url: "/admin/marathon-results/export",
            method: "GET",
            params,
        }),
    },
    getTicketsForExport: {
        query: (params: { type: number }) => ({
            url: "/admin/marathon-results/tickets",
            method: "GET",
            params,
        }),
    },

    // Betting & Choose Ticket flows
    makeMarathonBet: {
        query: (marathonId: string) =>
            `/admin/marathon/${marathonId}/bet-participants`,
    },
    choosenMarathonBet: {
        query: (body: { id: string; choosen_id: number }) => ({
            url: `/admin/marathon/${body.id}/bet`,
            method: "POST",
            body,
        }),
    },
    getMarathonChooseTicket: {
        query: (marathonId: string) => `/admin/marathon/${marathonId}/tickets`,
    },
    saveMarathonChosenTicket: {
        query: (body: {
            id: string;
            ticket_id: number;
            chosen_number: number;
        }) => ({
            url: `/admin/marathon/${body.id}/choose-ticket`,
            method: "POST",
            body,
        }),
    },
};

export const marathonTags = [
    "MarathonData",
    "MarathonStatistics",
    "AdminMarathons",
    "AdminMarathonParticipants",
    "AdminMarathonTickets",
    "AdminMarathonBets",
    "AdminMarathonStats",
    "AdminMarathonWinners",
] as const;
